var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  id: "svg2",
  width: 274.21332,
  height: 65.653336,
  viewBox: "0 0 274.21332 65.653336"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
  id: "defs6"
})), /*#__PURE__*/React.createElement("g", {
  id: "g10",
  transform: "matrix(1.3333333,0,0,-1.3333333,0,65.653333)"
}, /*#__PURE__*/React.createElement("g", {
  id: "g12",
  transform: "scale(0.1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m 1160.46,225.523 c 8.65,0 15.13,0.997 19.46,2.993 7.65,3.492 11.47,10.39 11.47,20.703 0,11.14 -3.7,18.625 -11.1,22.449 -4.16,2.16 -10.39,3.242 -18.7,3.242 h -44.65 v -49.387 h 43.52 z m -3.86,-30.433 h -39.66 v -72.086 h -37.54 v 183.832 h 90.17 c 12.88,-0.246 22.8,-1.828 29.74,-4.738 6.94,-2.91 12.83,-7.192 17.65,-12.844 3.99,-4.66 7.15,-9.813 9.48,-15.465 2.32,-5.656 3.49,-12.101 3.49,-19.332 0,-8.73 -2.2,-17.316 -6.61,-25.754 -4.41,-8.441 -11.68,-14.406 -21.83,-17.898 8.48,-3.41 14.49,-8.254 18.03,-14.528 3.53,-6.281 5.3,-15.863 5.3,-28.75 v -12.343 c 0,-8.403 0.33,-14.094 0.99,-17.09 1,-4.739 3.33,-8.231 6.99,-10.477 v -4.613 h -42.28 c -1.17,4.074 -2,7.359 -2.5,9.851 -0.99,5.157 -1.53,10.438 -1.62,15.84 l -0.25,17.086 c -0.16,11.727 -2.3,19.539 -6.42,23.449 -4.11,3.907 -11.83,5.86 -23.13,5.86",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path14"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 1331.45,204.57 c -0.59,9.395 -3.43,16.524 -8.55,21.391 -5.11,4.863 -11.45,7.293 -19.02,7.293 -8.23,0 -14.61,-2.578 -19.14,-7.731 -4.53,-5.156 -7.38,-12.14 -8.54,-20.953 z m 35.17,-41.656 c -0.92,-8.066 -5.12,-16.254 -12.6,-24.566 -11.64,-13.223 -27.94,-19.832 -48.89,-19.832 -17.29,0 -32.55,5.57 -45.77,16.711 -13.22,11.14 -19.83,29.265 -19.83,54.378 0,23.528 5.97,41.571 17.9,54.125 11.93,12.555 27.41,18.833 46.45,18.833 11.31,0 21.5,-2.122 30.56,-6.36 9.06,-4.242 16.55,-10.933 22.45,-20.082 5.32,-8.062 8.77,-17.418 10.35,-28.058 0.91,-6.239 1.29,-15.215 1.12,-26.942 h -93.04 c 0.5,-13.637 4.78,-23.195 12.85,-28.683 4.9,-3.411 10.81,-5.114 17.71,-5.114 7.31,0 13.26,2.078 17.83,6.239 2.5,2.242 4.7,5.359 6.61,9.351 h 36.3",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path16"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 1434.03,262.813 c 16.96,0 30.81,-3.368 41.53,-10.102 10.64,-6.82 16.75,-18.543 18.34,-35.172 h -35.55 c -0.5,4.574 -1.79,8.191 -3.87,10.852 -3.9,4.82 -10.56,7.234 -19.95,7.234 -7.73,0 -13.24,-1.207 -16.52,-3.617 -3.29,-2.414 -4.93,-5.238 -4.93,-8.481 0,-4.074 1.75,-7.027 5.24,-8.855 3.49,-1.914 15.84,-5.195 37.04,-9.852 14.13,-3.328 24.73,-8.355 31.8,-15.09 6.98,-6.82 10.48,-15.343 10.48,-25.57 0,-13.469 -5.01,-24.465 -15.03,-32.984 -10.02,-8.524 -25.51,-12.785 -46.46,-12.785 -21.37,0 -37.14,4.511 -47.33,13.531 -10.18,9.019 -15.28,20.516 -15.28,34.484 h 36.05 c 0.75,-6.32 2.37,-10.808 4.86,-13.468 4.41,-4.739 12.55,-7.11 24.45,-7.11 6.98,0 12.53,1.039 16.64,3.117 4.12,2.078 6.18,5.196 6.18,9.356 0,3.988 -1.67,7.023 -4.99,9.105 -3.33,2.074 -15.67,5.653 -37.04,10.723 -15.38,3.824 -26.23,8.605 -32.55,14.344 -6.32,5.652 -9.48,13.8 -9.48,24.441 0,12.555 4.93,23.344 14.78,32.367 9.85,9.02 23.71,13.532 41.59,13.532 v 0",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path18"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 1548.55,258.945 V 123.004 h -36.04 v 135.941 z m 0,49.016 V 275.16 h -36.04 v 32.801 h 36.04",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path20"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 1599.74,190.102 c 0,-12.555 2.5,-22.575 7.48,-30.055 4.91,-7.567 12.39,-11.352 22.45,-11.352 10.06,0 17.71,3.743 22.95,11.227 5.24,7.484 7.86,17.168 7.86,29.058 0,16.629 -4.2,28.516 -12.6,35.668 -5.16,4.325 -11.14,6.485 -17.96,6.485 -10.39,0 -18.02,-3.926 -22.88,-11.785 -4.87,-7.856 -7.3,-17.606 -7.3,-29.246 z m 95.78,116.488 V 123.004 h -34.54 v 18.832 c -5.08,-8.063 -10.85,-13.926 -17.34,-17.582 -6.48,-3.66 -14.55,-5.488 -24.19,-5.488 -15.89,0 -29.25,6.422 -40.1,19.265 -10.85,12.848 -16.28,29.332 -16.28,49.453 0,23.196 5.35,41.446 16.03,54.75 10.68,13.301 24.96,19.954 42.84,19.954 8.23,0 15.55,-1.805 21.95,-5.422 6.4,-3.618 11.6,-8.629 15.59,-15.032 v 64.856 h 36.04",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path22"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 1800.11,204.57 c -0.58,9.395 -3.43,16.524 -8.54,21.391 -5.11,4.863 -11.45,7.293 -19.02,7.293 -8.23,0 -14.61,-2.578 -19.14,-7.731 -4.53,-5.156 -7.38,-12.14 -8.55,-20.953 z m 35.17,-41.656 c -0.91,-8.066 -5.11,-16.254 -12.59,-24.566 -11.64,-13.223 -27.94,-19.832 -48.89,-19.832 -17.3,0 -32.55,5.57 -45.77,16.711 -13.22,11.14 -19.83,29.265 -19.83,54.378 0,23.528 5.96,41.571 17.89,54.125 11.93,12.555 27.42,18.833 46.46,18.833 11.31,0 21.49,-2.122 30.56,-6.36 9.06,-4.242 16.54,-10.933 22.45,-20.082 5.32,-8.062 8.77,-17.418 10.35,-28.058 0.91,-6.239 1.28,-15.215 1.12,-26.942 h -93.04 c 0.5,-13.637 4.78,-23.195 12.85,-28.683 4.9,-3.411 10.81,-5.114 17.71,-5.114 7.31,0 13.26,2.078 17.83,6.239 2.5,2.242 4.7,5.359 6.61,9.351 h 36.29",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path24"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 1934.65,222.152 c -3.49,6.989 -10.14,10.477 -19.95,10.477 -12.06,0 -20.33,-5.109 -24.82,-15.34 -2.33,-5.402 -3.49,-12.305 -3.49,-20.699 v -73.586 h -35.42 v 135.691 h 34.29 v -19.828 c 4.58,6.985 8.9,12.012 12.98,15.09 7.31,5.488 16.58,8.231 27.81,8.231 14.05,0 25.54,-3.68 34.48,-11.036 8.94,-7.359 13.41,-19.562 13.41,-36.605 v -91.543 h -36.42 v 82.687 c 0,7.153 -0.96,12.637 -2.87,16.461 v 0",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path26"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 2056.65,148.324 v -26.566 l -16.84,-0.621 c -16.79,-0.582 -28.27,2.324 -34.42,8.726 -3.99,4.075 -5.99,10.352 -5.99,18.832 v 83.688 h -18.95 v 25.316 h 18.95 v 37.914 h 35.18 v -37.914 h 22.07 v -25.316 h -22.07 v -71.84 c 0,-5.57 0.7,-9.039 2.12,-10.41 1.41,-1.371 5.73,-2.059 12.97,-2.059 1.08,0 2.22,0.02 3.43,0.063 1.2,0.039 2.38,0.101 3.55,0.187",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path28"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 822.199,258.504 c 29.938,44.23 38.438,82.363 24.746,96.055 -4.25,4.25 -10.847,6.363 -19.254,6.363 -18.679,0 -46.285,-10.496 -76.773,-31.129 12.648,-9.758 25.383,-20.941 37.852,-33.41 12.472,-12.477 23.664,-25.219 33.429,-37.879",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path30"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 688.414,296.383 c 12.465,12.469 25.199,23.652 37.852,33.414 -30.493,20.629 -58.098,31.125 -76.774,31.125 -8.41,0 -15.008,-2.113 -19.258,-6.363 -13.691,-13.692 -5.187,-51.825 24.75,-96.055 9.762,12.66 20.954,25.402 33.43,37.879",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path32"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 813.418,246.203 c -9.824,13.113 -21.426,26.594 -34.832,40 -13.41,13.41 -26.883,24.973 -39.996,34.797 -13.113,-9.824 -26.582,-21.387 -39.996,-34.797 -13.406,-13.406 -25.004,-26.887 -34.832,-40 9.828,-13.109 21.426,-26.59 34.832,-39.996 13.406,-13.406 26.886,-25.008 39.996,-34.828 13.113,9.82 26.59,21.422 39.996,34.828 13.406,13.406 25.008,26.887 34.832,39.996",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path34"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 654.984,233.906 c -29.937,-44.23 -38.441,-82.367 -24.75,-96.058 13.688,-13.696 51.829,-5.192 96.063,24.754 -12.66,9.761 -25.406,20.949 -37.883,33.425 -12.476,12.477 -23.668,25.219 -33.43,37.879",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path36"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 857.129,127.668 c -7.145,-7.145 -17.254,-10.539 -29.445,-10.539 -23.891,0 -55.789,13.086 -89.094,36.461 -33.301,-23.375 -65.203,-36.461 -89.09,-36.461 -12.195,0 -22.301,3.391 -29.445,10.539 -21.141,21.141 -9.442,68.234 25.871,118.539 -35.313,50.301 -47.012,97.395 -25.871,118.531 21.14,21.145 68.23,9.45 118.535,-25.871 50.305,35.317 97.394,47.012 118.539,25.871 21.137,-21.136 9.441,-68.23 -25.875,-118.531 35.316,-50.305 47.012,-97.398 25.875,-118.539 z M 492.383,14.3984 H 123.102 c -59.9418,0 -108.7036,48.7657 -108.7036,108.7036 v 246.203 c 0,59.941 48.7618,108.703 108.7036,108.703 h 369.281 z m 22.508,478.0076 v 0 H 123.102 C 55.1133,492.406 0,437.293 0,369.305 V 123.102 C 0,55.1133 55.1133,0 123.102,0 h 369.281 v 0 h 369.305 c 67.988,0 123.101,55.1133 123.101,123.102 V 492.406 H 514.891",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path38"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 788.77,196.027 c -12.477,-12.476 -25.223,-23.664 -37.883,-33.425 44.234,-29.946 82.375,-38.45 96.058,-24.754 13.692,13.691 5.192,51.828 -24.746,96.058 -9.765,-12.66 -20.957,-25.402 -33.429,-37.879",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path40"
}), /*#__PURE__*/React.createElement("path", {
  d: "m 170.852,328.973 c 20.472,0 40.992,-4.586 48.8,-33.129 h 26.243 v -43.567 c -32.719,26.899 -103.657,10.024 -111.313,43.504 -4.027,17.614 13.543,33.192 36.27,33.192 z m -66.926,13.593 C 90.7148,326.094 84.8203,303.613 88.9023,285.293 c 10.5704,-47.43 54.5817,-55.004 86.9067,-59.207 25.527,-3.32 49.945,-7.953 49.296,-30.703 -0.679,-23.61 -27.289,-29.414 -44.757,-29.414 -45.496,0 -47.035,33.625 -47.035,33.625 H 84.3828 c 0.7149,-12.625 4.5352,-32.899 20.0782,-50.297 17.023,-19.063 42.559,-28.727 75.887,-28.727 25.57,0 48.855,8.332 65.547,23.121 v -20.328 h 45.628 v 58.09 l 16.149,17.664 46.094,-75.754 h 53.105 l -67.07,110.95 67.086,73.527 h -59.121 l -56.243,-61.594 v 123.059 h -45.628 v -29.817 c -1.489,1.926 -3.059,3.832 -4.821,5.696 -16.59,17.566 -40.5,26.472 -71.062,26.472 -35.348,0 -55.449,-15.816 -66.086,-29.09",
  style: {
    "fill": "#ffffff",
    "fillOpacity": 1,
    "fillRule": "nonzero",
    "stroke": "none"
  },
  id: "path42"
}))));
export default __webpack_public_path__ + "static/media/sk-logo.84974f86.svg";
export { SvgComponent as ReactComponent };